export default __webpack_public_path__ + "b0ccaf1c9c29593effadb7277edee765.ttf";